module.exports = __webpack_public_path__ + "static/media/share-filled.b40c870d.svg";